/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ plan_title: NonNullable<unknown>, plan_change_date: NonNullable<unknown> }} Subscribed_Card_Change_PlanInputs */

const en_subscribed_card_change_plan = /** @type {(inputs: Subscribed_Card_Change_PlanInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Plan changes to "${i?.plan_title}" on ${i?.plan_change_date}.`)
};

const ar_subscribed_card_change_plan = /** @type {(inputs: Subscribed_Card_Change_PlanInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`تغييرات الخطة إلى "${i?.plan_title}" في ${i?.plan_change_date}.`)
};

const de_subscribed_card_change_plan = /** @type {(inputs: Subscribed_Card_Change_PlanInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Planänderungen zu "${i?.plan_title}" auf ${i?.plan_change_date}.`)
};

const es_subscribed_card_change_plan = /** @type {(inputs: Subscribed_Card_Change_PlanInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`El plan cambia a ${i?.plan_title} en ${i?.plan_change_date}.`)
};

const fr_subscribed_card_change_plan = /** @type {(inputs: Subscribed_Card_Change_PlanInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Le plan change de "${i?.plan_title}" à ${i?.plan_change_date}.`)
};

const it_subscribed_card_change_plan = /** @type {(inputs: Subscribed_Card_Change_PlanInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Il piano cambia in "${i?.plan_title}" il ${i?.plan_change_date}.`)
};

const ja_subscribed_card_change_plan = /** @type {(inputs: Subscribed_Card_Change_PlanInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.plan_change_date}にプランが「${i?.plan_title}」に変更されます。`)
};

const ko_subscribed_card_change_plan = /** @type {(inputs: Subscribed_Card_Change_PlanInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.plan_change_date} 플랜이 "${i?.plan_title}"(으)로 변경됩니다.`)
};

const pt_br_subscribed_card_change_plan = /** @type {(inputs: Subscribed_Card_Change_PlanInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`O plano será alterado para "${i?.plan_title}" em ${i?.plan_change_date}.`)
};

const ru_subscribed_card_change_plan = /** @type {(inputs: Subscribed_Card_Change_PlanInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.plan_change_date} план меняется на «${i?.plan_title}»`)
};

const th_subscribed_card_change_plan = /** @type {(inputs: Subscribed_Card_Change_PlanInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`แผนเปลี่ยนแปลงเป็น "${i?.plan_title}" ในวันที่ ${i?.plan_change_date}`)
};

const tr_subscribed_card_change_plan = /** @type {(inputs: Subscribed_Card_Change_PlanInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Plan ${i?.plan_title} tarihinde ${i?.plan_change_date} olarak değiştirilecektir.`)
};

const zh_cn_subscribed_card_change_plan = /** @type {(inputs: Subscribed_Card_Change_PlanInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`方案变更日：${i?.plan_change_date} 后，变更为 ${i?.plan_title}`)
};

const zh_tw_subscribed_card_change_plan = /** @type {(inputs: Subscribed_Card_Change_PlanInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`方案變更日：${i?.plan_change_date}後，變更為${i?.plan_title}`)
};

/**
* | output |
* | --- |
* | "Plan changes to \"{plan_title}\" on {plan_change_date}." |
*
* @param {Subscribed_Card_Change_PlanInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const subscribed_card_change_plan = /** @type {((inputs: Subscribed_Card_Change_PlanInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Subscribed_Card_Change_PlanInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_subscribed_card_change_plan(inputs)
	if (locale === "ar") return ar_subscribed_card_change_plan(inputs)
	if (locale === "de") return de_subscribed_card_change_plan(inputs)
	if (locale === "es") return es_subscribed_card_change_plan(inputs)
	if (locale === "fr") return fr_subscribed_card_change_plan(inputs)
	if (locale === "it") return it_subscribed_card_change_plan(inputs)
	if (locale === "ja") return ja_subscribed_card_change_plan(inputs)
	if (locale === "ko") return ko_subscribed_card_change_plan(inputs)
	if (locale === "pt_br") return pt_br_subscribed_card_change_plan(inputs)
	if (locale === "ru") return ru_subscribed_card_change_plan(inputs)
	if (locale === "th") return th_subscribed_card_change_plan(inputs)
	if (locale === "tr") return tr_subscribed_card_change_plan(inputs)
	if (locale === "zh_cn") return zh_cn_subscribed_card_change_plan(inputs)
	return zh_tw_subscribed_card_change_plan(inputs)
});